import { useEffect } from "react";
import { getImageUrl } from '../../../../services/asset';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import Circle from 'ol/geom/Circle';
import { Style, Icon, Fill, Stroke } from 'ol/style';
import Translate from 'ol/interaction/Translate';
import { fromLonLat } from 'ol/proj';

export const useMarkerLayer = (mapInstance, value, isDraggingFeature, translateRef, locationFeatureRef) => {
  const { latitude, longitude, isPreciseLocation } = value;

  useEffect(() => {
    if (!mapInstance) {
      return;
    }

    // Create feature based on selected mode
    let locationFeature: Feature;
    const coordinates = fromLonLat([longitude, latitude])

    if (isPreciseLocation) {
      // Create a marker feature at the location
      locationFeature = new Feature({
        geometry: new Point(coordinates),
      });

      // Style the marker
      locationFeature.setStyle(
        new Style({
          image: new Icon({
            anchor: [0.5, 1],
            src: getImageUrl("pin.png"),
          }),
        })
      );
    } else {
      // randomize center of circle a bit
      const newLongitude = Math.random() > 0.5 ? coordinates[0] + 100 : coordinates[0] - 100
      const newLatitude = Math.random() > 0.5 ? coordinates[1] + 100 : coordinates[1] - 100


      // Create a circle feature (radius in meters, approximately 500m)
      locationFeature = new Feature({
        geometry: new Circle([newLongitude, newLatitude], 500),
      });

      // Style the circle
      locationFeature.setStyle(
        new Style({
          stroke: new Stroke({
            color: 'rgba(255, 0, 0, 0.8)',
            width: 2,
          }),
          fill: new Fill({
            color: 'rgba(255, 0, 0, 0.2)',
          }),
        })
      );
    }


    // Create a vector layer for the feature
    const markerLayer = new VectorLayer({
      source: new VectorSource({
        features: [locationFeature],
      }),
    });

    // Add marker layer to map
    mapInstance.addLayer(markerLayer);

    // Create Translate interaction to make the feature draggable
    const translate = new Translate({
      features: new VectorSource({
        features: [locationFeature]
      }).getFeaturesCollection()
    });

    // Track if we're currently dragging the feature
    isDraggingFeature.current = false;

    translate.on('translatestart', () => {
      isDraggingFeature.current = true;
    });
    translateRef.current = translate;

    // Add the interaction to the map
    mapInstance.addInteraction(translate);

    // Store map instance and location feature for the return button
    locationFeatureRef.current = locationFeature;

    // Cleanup function to remove layer and interaction
    return () => {
      mapInstance.removeLayer(markerLayer);
      mapInstance.removeInteraction(translate);
    };
  }, [mapInstance, isPreciseLocation, latitude, longitude]);
}


// WEBPACK FOOTER //
// ./src/containers/AdFormPage/LocationSelector/hooks/useMarkerLayer.ts